import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PucaComponent } from './puca.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PartialsModule } from '../../partials/partials.module';
import { LightboxModule } from 'ngx-lightbox/lightbox.module';
import { CoreModule } from '../../../core/core.module';
import { SharedModule } from '../../../shared/shared-components/shared.module';
import { ProfileComponent } from './components/profile/profile.component';
import { EducationComponent } from './components/education/education.component';
import { AttestationDetailsComponent } from './components/attestation-details/attestation-details.component';
import { ReviewDetailsComponent } from './components/review-details/review-details.component';
import { UploadDocumentsComponent } from './components/upload-documents/upload-documents.component';
import { UploadDocumentComponent } from '../../../shared/shared-components/upload-documents/upload-document.component';
import { PucaService } from './services/puca.service';
import { AttestationDetailsService } from './components/attestation-details/services/attestation-details.service';
import { EducationService } from './components/education/services/education.service';
import { ReviewDetailsService } from './components/review-details/services/review-details.service';
import { UploadDocumentsService } from './components/upload-documents/services/upload-documents.service';
import { UploadAdditionalDocumentsService } from '../../../shared/shared-components/upload-additional-documents/services/upload-additional-documents.service';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { EmploymentDetailsComponent } from './components/employment-details/employment-details.component';
import { PucaFormComponent } from './components/puca-form/puca-form.component';import { PucaQuestionnaireComponent } from './components/puca-form/puca-questionnaire/puca-questionnaire.component';
import { PucaCitizenInformationComponent } from './components/puca-form/puca-citizen-information/puca-citizen-information.component';
import { PucaUndertakingComponent } from './components/puca-form/puca-undertaking/puca-undertaking.component';
import { PucaUploadDocumentsComponent } from './components/puca-form/puca-upload-Documents/puca-upload-Documents.component';
import { PucaProfessionalAccomplishmentComponent } from './components/puca-form/puca-professional-accomplishment/puca-professional-accomplishment.component';
import { PucaQuestionnaireService } from './components/puca-form/puca-questionnaire/service/puca-questionnaire.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MyHttpInterceptor } from '../../../../app/http.interceptor';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PartialsModule,
    LightboxModule,
    CoreModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: 'Application-Form',
        component: PucaComponent
	  },
	  //{ path: '', redirectTo: 'Application-Form', pathMatch: 'full', },
    ]),
  ],
  declarations: [
    PucaComponent,
    ProfileComponent,
    EducationComponent,
    AttestationDetailsComponent,
    ReviewDetailsComponent,
    UploadDocumentsComponent,
    UploadDocumentComponent,
    TermsConditionsComponent,
    EmploymentDetailsComponent,
	PucaFormComponent,
	PucaQuestionnaireComponent,
	PucaCitizenInformationComponent,
	PucaUndertakingComponent,
	PucaUploadDocumentsComponent,
	PucaProfessionalAccomplishmentComponent
  ],
  providers: [
    EducationService,
    AttestationDetailsService,
    ReviewDetailsService,
	UploadDocumentsService,
	UploadAdditionalDocumentsService,
	PucaQuestionnaireService,
	{
		provide: HTTP_INTERCEPTORS,
		useClass: MyHttpInterceptor,
		multi: true
	},
  ],
  bootstrap: [PucaComponent],
  exports:[PucaComponent]
})
export class PucaModule { }
